import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';

import { clearAuthData, logoutIntegration } from '../../../actions/Auth';

import Avatar from '../../../components/Avatar';

import { getOriginalUrlParams } from '../../../helpers/Mini';

const MiniHeaderProfile = ({
  profile,
  miniConfig,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <div className="profile-wrapper">
      <Dropdown
        isOpen={dropdownOpen}
        toggle={() => {
          setDropdownOpen(!dropdownOpen);
        }}
      >
        <DropdownToggle
          caret
          tag="span"
          data-toggle="dropdown"
          aria-expanded={dropdownOpen}
        >
          <Avatar user={profile} size={20} />
          <span className="profile-name">
            {profile.first_name ? profile.first_name : profile.name}
          </span>
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem header>
            {profile.client?.domain}
          </DropdownItem>
          <DropdownItem
            onClick={() => {
              logoutIntegration();
              clearAuthData();
              window.location = `/embed/login?${getOriginalUrlParams(miniConfig.urlParams)}`;
            }}
          >
            Disconnect
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};

const mapStateToProps = state => ({
  profile: state.Auth.profile,
  miniConfig: state.Mini.config,
});

MiniHeaderProfile.propTypes = {
  profile: PropTypes.object.isRequired,
  miniConfig: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(MiniHeaderProfile);
